import CaptchaToGenerateTableDto from 'app/admin/captchatogenerate/dto/CaptchaToGenerateTableDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class CaptchaToGenerateTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'captchaToGenerateTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<CaptchaToGenerateTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, CaptchaToGenerateTableDto)))
				.catch(reject);
		});
	}
}

export default new CaptchaToGenerateTableService();
